module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gSoMw"))).then(() => module.bundle.root('hEqeo'));